import { render } from "./UnwrapPeercoin.vue?vue&type=template&id=550d2beb&scoped=true"
import script from "./UnwrapPeercoin.vue?vue&type=script&lang=js"
export * from "./UnwrapPeercoin.vue?vue&type=script&lang=js"

import "./UnwrapPeercoin.vue?vue&type=style&index=0&id=550d2beb&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550d2beb"]])

export default __exports__